<div class="w-100 toggle-wrapper d-flex rounded-pill align-items-center justify-content-center">
  <div class="option-container">
    <div class="toggle-option" [ngClass]="!isAnual ? 'active' : 'deActive'" (click)="setIsAnual(false)">
      Mensal
    </div>
    <div class="toggle-option" [ngClass]="isAnual ? 'active' : 'deActive'" (click)="setIsAnual(true)">
      Anual
    </div>
  </div>
</div>
<div class="planos-scroll-container align-items-center justify-content-center mt-4">
  <div *ngFor="let plano of planos">
    <exibir-plano [assinaturaAnual]="assinaturaAnual" [assinatura]="assinatura" [plano]="plano" [planoAtual]="planoAtual" [isAnual]="isAnual" (onSelected)="selecionarPlano($event)"></exibir-plano>
  </div>
</div>
